/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    POST_REVIEW_FLAG_FAILURE,
    POST_REVIEW_FLAG_START,
    POST_REVIEW_FLAG_SUCCESS,
} from '../constants/types';
import { makeAsyncReducer } from '../utils/async_utils';

export const postReviewFlag = makeAsyncReducer(
    {
        startType: POST_REVIEW_FLAG_START,
        successType: POST_REVIEW_FLAG_SUCCESS,
        failureType: POST_REVIEW_FLAG_FAILURE,
    },
    { initialData: {} }
);

export const postReviewFlagSelector = (state) => state.ratingReviews.postReviewFlag;
